import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import ExemptionViewModel from "viewModels/notice/exemption/exemptionViewModel";
import Button from "@edaz/edazkit/Button";
import { IconType } from "@edaz/edazkit/Icon";
import { Col, Row } from "react-bootstrap";
import OmissionViewModel from "../../../../viewModels/notice/omission/omissionViewModel";
import LicensePlateChangeViewModel from "../../../../viewModels/notice/licensePlateChange/licensePlateChangeViewModel";
import DocumentsUploadedViewModel from "viewModels/notice/components/documentsUploadedViewModel";
import RefundRequestViewModel from "../../../../viewModels/notice/refundRequest/refundRequestViewModel";

type ToolboxViewModel =
  | ExemptionViewModel
  | OmissionViewModel
  | LicensePlateChangeViewModel
  | RefundRequestViewModel
  | DocumentsUploadedViewModel;

const Toolbox: FunctionComponent<{
  vm: ToolboxViewModel;
}> = observer(({ vm }) => {
  const tg = (code: string) => vm.translateGeneral(`toolbox.${code}`);

  return (
    <Row className="justify-content-center">
      {vm.canCancelNotice && (
        <Col sm={10} xl={4} className="p-2">
          <Button variant="light" onClick={vm.cancel} size="sm" className="m-0 pr-4 pl-4 mb-2 mb-lg-2 btn-block">
            {tg("cancel")}
          </Button>
        </Col>
      )}
      {vm.canSaveNoticePDF && (
        <Col sm={10} xl={4} className="p-2">
          <Button
            iconLeft={IconType.Save}
            variant="primary"
            onClick={vm.savePDF}
            disabled={(!(vm instanceof ExemptionViewModel) && vm.isContinueDisabled) ?? false}
            size="sm"
            className="m-0 pr-4 pl-4 mb-2 mb-lg-2 btn-block">
            {tg("savePDF")}
          </Button>
        </Col>
      )}
      {vm.canPrintNotice && (
        <Col sm={10} xl={4} className="p-2">
          <Button
            iconLeft={IconType.Print}
            variant="primary"
            onClick={vm.printPDF}
            disabled={(!(vm instanceof ExemptionViewModel) && vm.isContinueDisabled) ?? false}
            size="sm"
            className="m-0 pr-4 pl-4 mb-2 mb-lg-2 btn-block">
            {tg("printPDF")}
          </Button>
        </Col>
      )}
      {vm.canProceedToExternalService && (
        <Col sm={10} xl={4} className="p-2">
          <Button
            variant="primary"
            onClick={vm.continue}
            iconRight={IconType.ArrowRight}
            disabled={(!(vm instanceof ExemptionViewModel) && vm.isContinueDisabled) ?? false}
            size="sm"
            className="pr-4 pl-4 mb-2 mb-lg-2 btn-block">
            {tg("continue")}
          </Button>
        </Col>
      )}
    </Row>
  );
});

export default Toolbox;
